import Axios from "axios";

export default {
    getBudgetGraphic(broker,year,startWeek,endWeek,typeProduction,branchOffice,typeOfLineBusiness,codeBranchOffice,typeOfCodeLineBusiness,codeTypeProduction,codeApsVt) {
    const axiosInstance = Axios.create({
        timeout: 600000,
        headers: { TOKEN: 'Bearer ' + localStorage.getItem("accessToken") }
    }); 
    return axiosInstance.get("/commercialGraphics/getBudgetGraphic?broker="
    +broker+"&year="+year+"&startWeek="+startWeek+"&endWeek="+endWeek+"&typeProduction="+
    typeProduction+"&branchOffice="+branchOffice+"&typeOfLineBusiness="+typeOfLineBusiness+"&codeBranchOffice="+codeBranchOffice+"&typeOfCodeLineBusiness="+typeOfCodeLineBusiness+"&codeTypeProduction="+codeTypeProduction+"&codeApsVt="+codeApsVt);
  },
   getProductionBySucursal(broker,year,startWeek,endWeek,typeProduction,branchOffice,typeOfLineBusiness) {
    const axiosInstance = Axios.create({
        timeout: 600000,
        headers: { TOKEN: 'Bearer ' + localStorage.getItem("accessToken") }
    }); 
    return axiosInstance.get("/commercialGraphics/getProductionBySucursal?broker="
    +broker+"&year="+year+"&startWeek="+startWeek+"&endWeek="+endWeek+"&typeProduction="+
    typeProduction+"&branchOffice="+branchOffice+"&typeOfLineBusiness="+typeOfLineBusiness);
  },

  getRenewalAnalysisGraphic(broker,year,startWeek,endWeek,indicator,branchOffice) {
    const axiosInstance = Axios.create({
      timeout: 600000,
      headers: { TOKEN: 'Bearer ' + localStorage.getItem("accessToken") }
  }); 
  return axiosInstance.get("/commercialGraphics/getRenewalAnalysisGraphic?broker="
    +broker+"&year="+year+"&startWeek="+startWeek+"&endWeek="+endWeek+"&indicator="+
    indicator+"&branchOffice="+branchOffice);
  },
  getParetoGraphic(broker, year, startWeek, endWeek, indicator, branchOffice, percent) {
    const axiosInstance = Axios.create({
      timeout: 600000,
      headers: { TOKEN: 'Bearer ' + localStorage.getItem("accessToken") }
  }); 
  return axiosInstance.get("/commercialGraphics/getParetoGraphic?broker="
    +broker+"&year="+year+"&startWeek="+startWeek+"&endWeek="+endWeek+"&indicator="+
    indicator+"&branchOffice="+branchOffice+"&percent="+percent);
  },

  getSinistralityGraphic(broker,year,startWeek,endWeek,indicator,branchOffice) {
    const axiosInstance = Axios.create({
      timeout: 600000,
      headers: { TOKEN: 'Bearer ' + localStorage.getItem("accessToken") }
  }); 
  return axiosInstance.get("/commercialGraphics/getSinistralityGraphic?broker="
    +broker+"&year="+year+"&startWeek="+startWeek+"&endWeek="+endWeek+"&indicator="+
    indicator+"&branchOffice="+branchOffice);
  },
    getTypeLineBusiness() {
    return Axios.get("/catalogs/getLineBusiness");

  },
  getComparateYearGraphic(firstYear, secondYear,broker) {
    const axiosInstance = Axios.create({
      headers: { TOKEN: 'Bearer ' + localStorage.getItem("accessToken") }
  }); 
  return axiosInstance.get("/commercialGraphics/getComparateYear?firstYear="
    +firstYear+"&secondYear="+secondYear+"&broker="+broker);
  },
    
   getProductionByComercialWeekGraphic(model) {
    const axiosInstance = Axios.create({
      headers: { TOKEN: 'Bearer ' + localStorage.getItem("accessToken") }
    }); 
  return axiosInstance.post("/commercialGraphics/getProductionByComercialWeek",model);
  },
   
  getDetalleSemanaExcel( broker, year, startWeek, endWeek, typeProduction, branchOffice, typeOfLineBusiness) {		
    

    let url = "/commercialGraphics/getDetalleSemanaExcel?broker="
    +broker+"&year="+year+"&startWeek="+startWeek+"&endWeek="+endWeek+"&typeProduction="+
    typeProduction+"&branchOffice="+branchOffice+"&typeOfLineBusiness="+typeOfLineBusiness;
    
    console.log(url);
		return Axios.get(url , {
			responseType: 'arraybuffer'
		});
  },
  getBonoNuevoRiesgo(broker, year, startWeek, endWeek, typeProduction, branchOffice, typeOfLineBusiness) {
      
      let url = "/commercialGraphics/getBonosNuevoRiesgo?broker="
    +broker+"&year="+year+"&startWeek="+startWeek+"&endWeek="+endWeek+"&typeProduction="+
    typeProduction+"&branchOffice="+branchOffice+"&typeOfLineBusiness="+typeOfLineBusiness;
    
		return Axios.get(url);

  },
    getPresupuestoRenovacion(broker, year, startWeek, endWeek, typeProduction, branchOffice, typeOfLineBusiness) {
      
      let url = "/commercialGraphics/getPrepuestoRenovacion?broker="
    +broker+"&year="+year+"&startWeek="+startWeek+"&endWeek="+endWeek+"&typeProduction="+
    typeProduction+"&branchOffice="+branchOffice+"&typeOfLineBusiness="+typeOfLineBusiness;
    
		return Axios.get(url);

  },

  
};